"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../utils");
var _12_1 = __importDefault(require("./12"));
var _2_1 = __importDefault(require("./2"));
var _7_1 = __importDefault(require("./7"));
exports.default = (function (transparent48) { return function (raw) {
    var frameType = utils_1.hexToDec(raw.slice(4, 6));
    switch (frameType) {
        case 2: // 设备请求校验设备ID云端应答帧
            _2_1.default(transparent48)(raw);
            break;
        case 4: // 设备请求身份认证云端应答帧
            transparent48.virtual['[[RESOLVE]]']();
            transparent48.virtual.send('heartbeat');
            break;
        case 7: // App发送命令的帧
            transparent48.virtual.send('appSendResp');
            _7_1.default(transparent48)(raw);
            break;
        case 12: // 心跳帧应答
            _12_1.default(transparent48)(raw);
            break;
        case 6: // 设备上报详情云端应答帧
        case 10: // 设备发送数据到App云端应答帧
            break;
        default:
            console.error("Error: " + frameType + " " + raw);
            break;
    }
}; });



// WEBPACK FOOTER //
// ./src/transparent48/decode/index.ts